export default __webpack_public_path__ + "static/media/Marina.1ce5b6bd.jpg";